/*
 * --------------------------------------------------------------------------- *
 * File: CollateralSearch.js                                                   *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useContext, useEffect, useState } from "react";
import { Cloud } from "../main/cloud";
import Constants from "../main/constants";
import { AppContext } from "../main/context";

function CollateralSearch() {
  const { customerId, setCustomerId, setShowNow, setCollateral } = useContext(AppContext);
  const [collateralList, setCollateralList] = useState([]);

  const fetchCollateralList = async () => {
    var list = await Cloud.post(`${Constants.apiBaseUrl}`, {
      action: "GET_CUSTOMER_COLLATERALS",
      data: { id: customerId },
    });
    setCollateralList(list);
    setCollateral({});
  };

  var list = collateralList.map((c, i) => (
    <button
      className="wide btn btn-outline-primary rounded left p-3"
      key={i}
      onClick={() => {
        setCollateral(c);
        setShowNow(Constants.SHOW_NOW_EDIT_COLLATERAL);
      }}
    >
      {c.customerId} : {c.type}
    </button>
  ));

  return (
    <>
      <div className="row pt-2 pb-4">
        <div className="col-12">
          <h2 className="center">Search</h2>
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
          <input
            type="text"
            placeholder="Customer ID"
            value={customerId}
            className="wide"
            onChange={(e) => {
              setCustomerId(e.target.value);
            }}
          />
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
          <input
            type="text"
            placeholder="Field 2"
            className="wide"
            onChange={(e) => {
              setCustomerId(e.target.value);
            }}
          />
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
          <input
            type="text"
            placeholder="Field 3"
            className="wide"
            onChange={(e) => {
              setCustomerId(e.target.value);
            }}
          />
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
          <input
            type="text"
            placeholder="Field 4"
            className="wide"
            onChange={(e) => {
              setCustomerId(e.target.value);
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 right">
          <button className="btn btn-outline-primary mb-4" onClick={(e) => fetchCollateralList()}>
            Search
          </button>
          <hr />
        </div>
      </div>
      <div className="row pt-3">
        <div className="col-12">{list}</div>
      </div>
    </>
  );
}

export default CollateralSearch;
